<template>
    <div class="modal fade " id="sendToCustomerModal">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header bg-soft-info p-3">
                    <h5 class="modal-title">Send To Customer</h5>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div class="row mb-2">
                        <div class="col-md-12">
                            <label>Customer email address:</label>
                            <div>
                                <!--<span class="text-primary" v-if="customer_contact">
                                    {{ customer_contact.email}}
                                </span>
                                <span class="text-primary" v-else-if="order.customer">
                                    {{ order.customer.customer_contacts && order.customer.customer_contacts.length ? order.customer.customer_contacts[0].email : order.customer.email}}
                                </span>-->

                            <!-- <input type="email" name="customer_email" v-model="customer_email" class="form-control"> -->
                             <!-- <InputTag v-model="customer_email" id="cc1" placeholder="Comma separated email addresses"
                                    :add-tag-on-blur="true"
                                    validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                            ></InputTag> -->


                            <v-select label="contact_email" :filterable="false" multiple
                                        v-model="customer_email"
                                        :options="customers"
                                        placeholder="Customer"
                                        :reduce="customer => customer.contact_email"
                                        @input="onCustomerSelect"
                                        @search="onCustomerSearch"
                                        @selected="onCustomerSelect"
                                        @deselected="onCustomerDeSelect">
                                    <template slot="no-options">
                                        type to search customers..
                                    </template>
                                    <!-- <template slot="option" slot-scope="option">
                                        <div class="d-center" v-html="option.html">
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center" v-html="option.text">
                                        </div>
                                    </template> -->
                                    <template #option="{ html }">
                                        <div class="d-center" v-html="html"></div>
                                    </template>

                                    <template #selected-option="{ contact_email }">
                                        <div class="selected d-center">{{ contact_email }}</div>
                                    </template>
                                </v-select>

                            </div>
                        </div>

                    </div>
                    <div class="form-group">
                        <div class="d-flex justify-content-between mt-1">
                            <a href="javascript:void(0);" class="badge badge-soft-primary fs-13" id="addCC" v-on:click="toggleCC"><span > {{isCC ? 'Remove CC' : 'Add CC'}}</span></a>
                            <a href="javascript:void(0);" class="badge badge-soft-primary fs-13" id="addBCC" v-on:click="toggleBCC"><span > {{isBCC ? 'Remove BCC' : 'Add BCC'}}</span></a>
                        </div>
                    </div>

                    <div class="form-group" v-if="isCC == true">
                        <label for="cc">CC</label>
                        <!--<input type="email" class="form-control" id="cc" placeholder="cc" v-model="cc">-->
                        <!-- <InputTag v-model="cc" id="cc" placeholder="Comma separated CC email addresses"
                                  :add-tag-on-blur="true"
                                  validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                        ></InputTag> -->

                        <v-select label="contact_email" :filterable="false" multiple
                                        v-model="cc"
                                        :options="customersCC"
                                        placeholder="Customer"
                                        :reduce="customer => customer.contact_email"
                                        @input="onCustomerSelectCC"
                                        @search="onCustomerSearchCC"
                                        @selected="onCustomerSelectCC"
                                        @deselected="onCustomerDeSelectCC">
                                    <template slot="no-options">
                                        type to search customers..
                                    </template>
                                    <!-- <template slot="option" slot-scope="option">
                                        <div class="d-center" v-html="option.html">
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center" v-html="option.text">
                                        </div>
                                    </template> -->
                                    <template #option="{ html }">
                                        <div class="d-center" v-html="html"></div>
                                    </template>

                                    <template #selected-option="{ contact_email }">
                                        <div class="selected d-center">{{ contact_email }}</div>
                                    </template>
                                </v-select>

                    </div>


                    <div class="form-group" v-if="isBCC == true">
                        <label for="bcc">BCC</label>
                        <!--<input type="email" class="form-control" id="bcc" placeholder="bcc" v-model="bcc">-->
                        <InputTag v-model="bcc" id="bcc" placeholder="Comma separated BCC email addresses"
                                  :add-tag-on-blur="true"
                                  validate="email" :add-tag-on-keys="[9,13, 32, 188]"
                        ></InputTag>
                    </div>

                    <div class="form-group">
                        <label for="subject">Subject</label>
                        <input type="text" class="form-control" id="subject" placeholder="" v-model="subject">
                    </div>


                    <div class="form-group">
                        <!--<label for="message_body">Hello</label>-->
                        <ckeditor v-model="message_body"
                                  tag-name="textarea"
                                  value="Hello, <p>Please Enter Message</p>"
                                  :config="editorConfigMin"></ckeditor>
                        <!--<VueEditor v-model="message_body" :editorToolbar="getXSmallQuillToolbar()"></VueEditor>-->
                    </div>
                    <div class="form-group">
                        <div class="form-check">
                            <input v-model="order.is_artwork_required" type="checkbox" class="form-check-input" />
                            <label class="form-check-label">Is artwork required?</label>
                        </div>
                        <div class="form-check">
                            <input v-model="order.is_deposit_required" type="checkbox" class="form-check-input" />
                            <label class="form-check-label">Is deposit required?</label>
                        </div>
                        <div class="form-check">
                            <input v-model="order.is_sample_required" type="checkbox" class="form-check-input" />
                            <label class="form-check-label">Is sample required?</label>
                        </div>
                        <div class="form-check">
                            <input v-model="order.is_no_artwork" type="checkbox" class="form-check-input" />
                            <label class="form-check-label">No Artwork</label>
                        </div>
                        <div class="form-check">
                            <input v-model="order.is_repeat_order" type="checkbox" class="form-check-input" />
                            <label class="form-check-label">Repeat Order</label>
                        </div>
                        <div class="error" v-if="artworkFilesInvalid">At least one of the 5 checkboxes must be selected</div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <label>Attachments</label>
                        </div>
                        <div class="col-12">
                            <div class="pdf-dwn-sec line-hgt">
                                <span class="orderbtnsec">
                                    <a class="btn btn-primary" href="javascript:void(0)" @click="downloadPdf()">Download Order PDF</a>
                                </span>
                            </div>
                        </div>

                        <div class="col-12">
                            <!--<label for="attach">Add Attachment</label> <br>-->
                            <vue-dropzone :options="dropzoneOptions"
                                          :id="'item-dropzone-attach'"
                                          v-on:vdropzone-success="(file, response) => afterUploadComplete(file, response)">
                            </vue-dropzone>
                        </div>

                        <div class="col-12" v-if="attachments.length > 0">
                            <template v-for="(item, index) in attachments">
                                <div class="pdf-dwn-sec line-hgt">
                                    {{item.attach_link}}
                                    <span class="orderbtnsec">
                                        <a href="javascript:void(0)" v-on:click="download(item)">
                                            Download</a>

                                        <a href="javascript:void(0)" class="trash_btn"
                                           @click="deleteAttachmentFile(index)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                    </span>
                                </div>
                            </template>
                        </div>
                        <div class="col-12">
                            <template v-if="attached_files.length > 0">
                                <template v-for="(item, index) in attached_files">
                                    <div class="pdf-dwn-sec line-hgt" :class="'vendor_num_' + index">
                                        <img v-if="item.url && (item.file_ext.toLowerCase() == 'png' || item.file_ext.toLowerCase() == 'jpeg' || item.file_ext.toLowerCase() == 'jpg')"
                                             :src="item.url" style="width:70px;height:70px">
                                        {{item.filename}}
                                        <a href="javascript:void(0)" class="trash_btn"
                                           @click="deleteAttachFile(index)"><i class="fa fa-trash-alt fa-pull-right"></i></a>
                                    </div>
                                </template>
                            </template>
                        </div>

                    </div>

                    <div class="mt-3">
                        <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="confirmSendToCustomer">Send Mail</button>
                    </div>
                </div>

                <!-- Modal footer -->


            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import InputTag from "vue-input-tag";
import { VueEditor } from "vue2-editor";
import Vue from "vue";

export default {
    name: "SendOrderToCustomer",
    components: {
        DatePicker,
        vueDropzone: vue2Dropzone,
        InputTag,
        VueEditor
    },
    props: ['order', 'customer_contact'],
    created() {

    },
    beforeMount() {
        let email = null;
        if(this.customer_email.length == 0) {
            if(this.customer_contact) {
                email = this.customer_contact.email;
            } else if(this.order.customer) {
                email = this.order.customer.customer_contacts &&
                this.order.customer.customer_contacts.length ? this.order.customer.customer_contacts[0].email : this.order.customer.email;
            }
        }

        if (email) {
            this.customers = [{  contact_email: email, html: email, text: email }]
            this.customer_email = [email];
        }

        this.getSendToCustomerSettings();
    },
    mounted() {
        let self = this;
        $("#sendToCustomerModal").on('show.bs.modal', () => {
            self.attachments = _.cloneDeep(this.order.attachments);
        });
    },
    data() {
        return {
            customers: [],
            customersCC:[],
            submitted: false,
            isCC: false,
            media_id: null,
            media_ids: [],
            customer_email: [],
            cc: [],
            isBCC: false,
            bcc: [],
            subject: null,
            message_body: "Please Enter Message",
            adminUser: null,
            smtp_user: null,
            dropzoneOptions: {
                url: window.route('medias.store'),
                thumbnailWidth: 150,
                maxFilesize: 2048, //mb
                maxFiles: 5,
                addRemoveLinks: false,
                chunking: false,
                //chunkSize: 500, // bytes
                headers: {
                    "Authorization": 'Bearer ' + localStorage.getItem('token'),
                    "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]").content
                }
            },
            editorConfigMin: {
                enterMode: 2,
                removePlugins: 'elementspath',
                resize_enabled: false,
                toolbar: [
                    [ 'Source', '-', 'Bold', 'Italic' ],
                    [ 'Styles', 'Format', 'Font', 'FontSize' ],
                ]
            },
            attached_files: [],
            artworkFilesInvalid: false,
            attachments: []
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
            'setNewPurchaseOrder'
        ]),
        onCustomerSelect(event) {
            if (event) {
                this.filterData.search_customer_id = event.id;
            } else {
                this.filterData.search_customer_id = null;
            }
        },
        onCustomerDeSelect(event) {
            this.filterData.search_customer_id = null;
        },
        onCustomerSearch(search, loading) {
            if (search.length) {
                loading(true);
                this.searchCustomerNew(loading, search, this);
            }
        },
        searchCustomerNew: _.debounce((loading, search, vm) => {
            return axios.post(window.route('searchCustomer'), {searchTerm: search, contactType: 1}, {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {

                    } else {
                        vm.customers = data.data;
                    }
                })
                .catch((error) => {

                })
                .finally(() => {
                    //self.setLoading(false);
                    loading(false);
                });
        }, 350),

        /// CC 
        onCustomerSelectCC(event) {
            if (event) {
                this.filterData.search_customer_id = event.id;
            } else {
                this.filterData.search_customer_id = null;
            }
        },
        onCustomerDeSelectCC(event) {
            this.filterData.search_customer_id = null;
        },
        
         onCustomerSearchCC(search, loading) {
            if (search.length) {
            loading(true);
            this.searchCustomerNewCC(loading, search, this);
            }
        },

        searchCustomerNewCC: _.debounce((loading, search, vm) => {
            axios.post(window.route('searchCustomer'), {
            searchTerm: search,
            contactType: 1
            }, {
            validateStatus: status => status < 500
            })
            .then(({ data }) => {
            if (!data.errorMessage) {
                vm.customersCC = data.data;
            }
            })
            .catch((error) => {
            console.error('Search error:', error);
            })
            .finally(() => {
            loading(false);
            });
        }, 350),
    
        downloadPdf() {
            let url = window.route('orders.download', {id: this.order.id});

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", "so_" + this.order.order_number + ".pdf");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        getSendToCustomerSettings() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(window.route('orders.sendToCustomer.settings'), {

                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errors && data.errors.length) {
                        self.setCommonErrors(data.errors);
                    } else if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                    } else {
                        let order_number = this.order.order_number;

                        let contact_name = "";
                        if(this.customer_contact) {
                            contact_name = this.customer_contact.contact_name;
                        }
                        let company_name = "";
                        if(this.order.customer) {
                            company_name = this.order.customer.company_name;
                        }


                        this.adminUser = data.data.adminUser;
                        this.smtp_user = data.data.smtp_user;
                        this.subject = data.data.so_send_to_customer_title.replace('__ORDER_NUMBER__', order_number)
                            .replace('__CUSTOMER_NAME__', contact_name)
                            .replace('__CUSTOMER_COMPANY_NAME__', company_name);
                        this.message_body = data.data.so_send_to_customer_body.replace('__ORDER_NUMBER__', order_number)
                            .replace('__CUSTOMER_NAME__', contact_name)
                            .replace('__CUSTOMER_COMPANY_NAME__', company_name);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        confirmSendToCustomer() {
            let self = this;
            if(this.order.so_status_id > 2) {
                Vue.$confirm({
                    title: 'Are you sure?',
                    message: `Are you sure you want to change order status to "Sent to Customer"?`,
                    button: {
                        yes: 'Yes',
                        no: 'Cancel'
                    },
                    callback: confirm => {
                        if (confirm) {
                            self.sendToCustomer(true);
                        } else {
                            self.sendToCustomer();
                        }

                    }
                });
            } else {
                this.sendToCustomer();
            }
        },
        sendToCustomer(downgrade_status = false) {
            if(!this.order.is_artwork_required && !this.order.is_deposit_required && !this.order.is_sample_required &&
                !this.order.is_no_artwork && !this.order.is_repeat_order) {
                this.artworkFilesInvalid = true;
                return false;
            }
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.post(window.route('orders.sendToCustomer', {id: this.order.id}), {
                subject: this.subject,
                customer_email: this.customer_email,
                cc: this.cc,
                bcc: this.bcc,
                message_body: this.message_body,
                media_id: this.media_id,
                media_ids: this.media_ids,
                isCC: this.isCC,
                isBCC: this.isBCC,
                is_artwork_required: this.order.is_artwork_required,
                is_deposit_required: this.order.is_deposit_required,
                is_sample_required: this.order.is_sample_required,
                is_no_artwork: this.order.is_no_artwork,
                is_repeat_order: this.order.is_repeat_order,
                attachments: this.attachments,
                downgrade_status: downgrade_status
            }, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if (data.errorMessage) {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    } else {
                        self.$emit('customerEmailSentEvent', data.data);
                        self.setSuccessMessage(data.message);
                        $('#sendToCustomerModal').modal('hide');
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },
        afterUploadComplete(file, response) {
            this.media_ids.push(response.data.media.id);
            let media = _.cloneDeep(response.data.media);
            media['url'] = response.data.url;
            this.attached_files.push(media);
        },
        deleteAttachFile(index){
            this.attached_files.splice(index, 1);
            this.media_ids.splice(index, 1);
        },
        toggleCC(){
          this.isCC = !this.isCC;

          if(!this.isCC) {
              this.cc = [];
          }
        },
        toggleBCC(){
            this.isBCC = !this.isBCC;
            if(!this.isBCC) {
                this.bcc = [];
            }
        },
        deleteAttachmentFile(index) {
            this.attachments.splice(index, 1);
        },
        download(media) {
            let url = window.route('medias.download', {
                path: 'so_attachments',
                id: this.order.id,
                name: media.attach_link,
                pdf_to_image: 0
            });

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);
            return axios.get(url, {
                responseType: "blob",
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    self.setLoading(false);
                    // Service that handles ajax call
                    const url = window.URL.createObjectURL(new Blob([data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("target", "_blank");
                    link.setAttribute("download", media.attach_link);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    },
    watch: {
        order: {
            handler: function (after, before) {
                if(!after.is_artwork_required && !after.is_deposit_required && !after.is_sample_required &&
                    !after.is_no_artwork && !after.is_repeat_order) {
                    this.artworkFilesInvalid = true;
                } else {
                    this.artworkFilesInvalid = false;
                }
            },
            deep: true,
        },
        'order.is_artwork_required': {
            handler: function (after, before) {
                if(after) {
                    this.order.is_no_artwork = false;
                }
            }
        },
        'order.is_no_artwork': {
            handler: function (after, before) {
                if(after) {
                    this.order.is_artwork_required = false;
                }
            }
        }

    }
}
</script>

<style scoped>

</style>
